const dict = {
  'Welcome to React': 'Reactとreact-i18nextへようこそ',
  error: {
    '404': 'ページが見つかりません',
  },
  pages: {
    user: {
      sectionTitle: {
        user: 'お客様情報',
        salon: '店舗情報',
        invoice: '請求書情報',
      },
      breadcrumb: {
        home: 'ホーム',
        userInfo: 'お客様情報',
      },
    },
    common: {
      home: 'ホーム',
      close: '閉じる',
      cancel: 'キャンセル',
      delete: '削除',
      edit: '編集',
      save: '保存',
      confirm: '確認',
      back: '戻る',
      next: '次へ',
      search: '検索',
      loading: '読み込み中...',
      error: 'エラー',
      success: '成功',
      warning: '警告',
      info: '情報',
      backorders: '未引き当て一覧',
      menu: {
        title: 'メニュー',
        confirmOrder: '注文を確認する',
        orderImport: '注文取込',
      },
    },
    contact: {
      title: 'お問い合わせ',
      form: {
        title: 'お問い合わせフォーム',
        notice:
          'ご注文内容・商品・請求書に関するお問い合わせは担当営業までご連絡ください。',
        emailNotice:
          '「{{email}}」からのメールを受信できるよう、受信設定をご確認ください。',
        businessHours: '営業時間：月曜から金曜　9：00～18：00',
        holidays:
          '定休日：土日祝日（営業時間外のお問合せは、翌営業日以降にご連絡いたします）',
      },
    },
    error: {
      title: 'エラー',
      messages: {
        401: '認証に失敗しました。\n再度ログインしてください。',
        403: '不正な操作が行われました。\n再度ログインしてください。',
        404: 'ページが見つかりませんでした。',
        500: 'アクセスしたページを表示できませんでした',
        default: 'エラーが発生しました',
      },
      loginButton: 'ログイン画面へ',
      orderHistoryDetailNotFound: {
        message: {
          line1: '誠に恐れ入りますが、ご注文内容につきましては',
          line2: 'TOP＞仕入情報※よりご確認いただきますようお願い申し上げます。',
        },
        note: {
          line1: '※こちらの項目が表示されない場合',
          line2:
            '「仕入情報」機能のご利用をご希望の場合は、担当営業へお問い合わせください。',
        },
      },
    },
    favorite: {
      title: 'お気に入りリスト',
      detail: {
        title: 'お気に入りリスト詳細',
        noItems: '{{favoriteTitle}}に{{itemTitle}}がありません',
        newListButton: '新規リストの作成',
        myList: 'マイリスト',
        sharedList: '共有リスト',
        sharedListNote: '共有リストは並び替えできません',
        sort: '並び替え',
        deleteConfirmation: 'リストを削除します',
        deleteWarning: 'この操作は取り消すことができません。',
        deleteButton: '削除する',
      },
      validation: {
        required: '必須項目です',
        minQuantity: '{{min}}未満です',
        maxQuantity: '{{max}}を超えています',
        maxNote: '{{max}}文字を超えています',
      },
    },
    guide: {
      title: 'ガイド',
      search: {
        title: '検索結果',
        placeholder: '{{guideTitle}}内のキーワード検索',
        backToTop: '{{guideTitle}}トップへ戻る',
        noResults:
          '条件に合う{{guideTitle}}がありません。\n条件を変更して再度検索してください。',
      },
    },
    invoice: {
      title: '請求書',
      download: {
        title: '請求書ダウンロード',
        description:
          '以下のファイルをダウンロードするためにはパスワードが必要です。',
        filename: '取引先コード_合計金額_日付.pdf',
        password: 'パスワード',
        downloadButton: 'ダウンロード',
        errors: {
          invalidPassword:
            '請求書のダウンロードができませんでした\nパスワードをご確認の上再度お試しください',
          notFound: 'ダウンロードする請求書が見つかリませんでした',
          systemError: 'システムエラーが発生しました',
        },
      },
    },
    item: {
      title: '商品',
      search: {
        title: '検索',
      },
      detail: {
        title: '詳細',
        productInfo: '商品詳細情報',
      },
    },
    login: {
      title: 'ログイン',
      fields: {
        loginId: 'ログインID',
        password: 'パスワード',
      },
      buttons: {
        login: 'ログイン',
      },
      errors: {
        invalidCredentials: 'ログインIDまたはパスワードが間違っています',
        systemError: 'システムエラーが発生しました',
      },
      messages: {
        logoutSuccess: 'ログアウトしました',
      },
    },
  },
  common: {
    yes: 'あり',
    no: 'なし',
    or: 'または',
    japanese: '日本語',
    english: '英語',
    symbol: {
      separator: '／',
    },
    action: {
      close: '閉じる',
      update: '更新する',
      save: '保存する',
      delete: '削除する',
    },
    error: {
      required: '必須です',
      invalid: '不正です',
      incorrect: '正しくありません',
      noItem: '商品がありません',
      null: '存在しません',
      status: '不正なステータスです',
      over: '規定の値を超えています',
      sameAsNow: '現在使用されている値です',
      statusCode: {
        '504':
          '処理に時間がかかり過ぎたため、正常に処理を終了できませんでした。\n少し時間をおいて再度操作してください。\n解決しない場合は、お手数をおかけしますが、お問い合わせフォームからお問い合わせください。',
        '400': {
          address: {
            searchByZipCode: '利用できない郵便番号です',
          },
          favorite: {
            copy: {
              expired: '販売終了商品です',
              unavailable: '販売期間外商品です',
              forbidden: '扱えない商品です',
            },
          },
          cart: {
            delivaryDate: {
              invalid: '存在しない日付です',
              incorrent: '最短納品日以降を選択してください',
            },
            order: {
              noItem: `カートに商品が追加されていません`,
              null: `カートが存在しません`,
            },
          },
          order: {
            deliveryDate: {
              over: '指定したご希望納品日の注文は締切時間を過ぎてしまったので変更が出来ません',
            },
          },
          user: {
            changeEmail: {
              sameAsNow: '現在と同じメールアドレスには変更できません',
            },
          },
        },
      },
      field: {
        itemCode: '商品コード',
        groupId: 'グループID',
        salonPriceLower: 'サロン価格下限',
        salonPriceUpper: 'サロン価格上限',
        retailPriceLower: 'メーカー希望小売価格下限',
        retailPriceUpper: 'メーカー希望小売価格上限',
        brandCodes: 'ブランド',
        categoryIds: 'カテゴリー',
        salesStartFrom: '販売開始範囲開始',
        salesStartTo: '販売開始範囲終了',
        keywords: '検索クエリワード',
        lineupCode: 'ラインアップコード',
        // 発注関連
        orderNo: '発注番号',
        deliveryDateFrom: '納品開始日',
        deliveryDateTo: '納品終了日',
        shipmentStatus: '出荷ステータス',
        approvalStatus: '承認ステータス',
        salesOrderNo: '販売注文番号',
        // お気に入り関連
        setNo: 'お気に入りリスト番号',
        // カート関連
        address1: '住所1',
        address2: '住所2',
        deliveryDate: '納品日',
        zipCode: '郵便番号',
        tel: '電話番号',
        deliveryName: 'お届け先名',
        desiredDeliveryDate: 'ご希望納品日',
        // 注文取込関連
        systemType: '取込種別',
        orderDateFrom: '取込日（開始日）',
        fileContent: 'ファイル内容',
        fileName: 'ファイル名',
        fileId: 'ファイルID',
        // 請求書関連
        invoiceId: '請求書ID',
        // 共通
        storeCode: '店舗コード',
        page: 'ページ番号',
        pageSize: '表示件数',
      },
    },
    detail: '詳細',
    required: '必須',
    receive: '受信する',
    doNotReceive: '受信しない',
    menu: {
      title: 'メニュー',
    },
    label: {
      itemUnit: '点',
      searchUnit: '件',
      yen: '円',
    },
    pagination: {
      fromTo: '全{{total}}件中{{from}}-{{to}}件',
    },
    filter: {
      title: '絞り込み',
      execute: '絞り込む',
      reset: '絞り込み条件をリセットする',
      search: '検索',
    },
    placeholder: {
      select: '選択してください',
      selectAll: 'すべて選択',
      unselectAll: 'すべて外す',
      all: 'すべて',
      itemSelected: '{{count}}件選択中',
      fromDate: '開始日',
      toDate: '終了日',
    },
  },
  backorders: {
    title: '未引き当て一覧',
    noItems: '未引き当ての商品はありません',
    orderNo: '受注番号',
    orderDate: '注文日',
    itemName: '商品名',
    itemCode: '商品コード',
    storeName: '店舗名',
    orderedAt: '注文日',
    buyerName: '注文者名',
    orderedQuantity: '注文数量',
    allocatedQuantity: '引当数量',
    unallocatedQuantity: '未引当数量',
    detail: '詳細',
    status: {
      all: '全数未引当',
      partial: '一部未引当',
    },
  },
  components: {
    dnd: {
      dropCsv: 'ここにCSVファイルをドラッグ&ドロップ',
      selectFile: 'ファイルを選択',
    },
  },
  login: {
    title: 'ログイン',
    employeeTitle: '社員モードログイン',
    employeeLoginLink: '社員モードでログイン',
  },
  top: {
    menu: {
      orderHistory: '注文履歴',
      favorite: 'お気に入り',
      search: '商品検索',
      orderImport: '注文取込',
      ecOrderImport: 'EC注文取込結果',
      import: '仕入情報',
      invoice: '請求書',
      logout: 'ログアウト',
      priceChangeHistory: '価格変更履歴',
      backorders: '未引き当て一覧',
      subtitle: {
        invoice: '請求書を確認する',
        other: 'その他',
      },
    },
    warning: {
      orderHistory: {
        approve: '承認が完了していない注文履歴があります',
      },
    },
  },
  user: {
    info: {
      title: 'お客様情報',
      userId: 'ユーザーID',
      email: 'メールアドレス',
      password: 'パスワード',
      change: '変更する',
      notSet: '設定なし',
      language: '言語設定',
    },
    email: {
      pendingVerification: '認証待ち',
      receiveSettings: {
        title: 'メール受信設定',
        changeTitle: 'メール受信設定の変更',
        changeMessage: 'メールの受信設定を変更しますか？',
        receiveOrderCompletionEmail: '注文完了メールを受信しますか？',
        orderCompletionEmail: '注文完了メール',
        invoiceEmail: '請求書公開通知メール',
        receive: '受信',
        receiveOption: '受信する',
        doNotReceiveOption: '受信しない',
        changeSuccess: 'メール受信設定が変更されました。',
      },
    },
    language: {
      title: '言語設定',
      changeTitle: '言語設定の変更',
      changeSuccess: '言語設定が変更されました。',
      close: '閉じる',
      message: {
        confirm: '表示中の言語を変更しますか？',
      },
    },
    invoice: {
      viewPermission: '閲覧権限',
      email: {
        notificationEmail: '請求書通知メール：受信',
        receive: 'する',
        doNotReceive: 'しない',
        receiveQuestion: '請求書通知メールを受信しますか？',
        receiveOption: '受信する',
        doNotReceiveOption: '受信しない',
      },
    },
    store: {
      storeCode: '店舗コード',
      storeName: '店舗名',
      shippingAddress: '配送先住所',
      phoneNumber: '電話番号',
      honorific: '様',
    },
  },
  maintenance: {
    message: 'ただいまメンテナンス中です',
    altairLogo: 'Altairロゴ',
  },
  order: {
    title: '発注する',
    addSalesType: '売上種別を追加する',
    salesType: '売上種別',
    completed: {
      message: '発注が完了しました',
      orderNumber: '発注番号',
      emailMessage: {
        line1: '発注の詳細をメールでお送りしました。',
        line2: 'メールが届かない場合は、迷惑メールフォルダをご確認ください。',
        line3: 'ご不明な点がございましたら、お気軽にお問い合わせください。',
      },
      employee: {
        success: '社員代理注文が完了しました',
        successWithWarnings:
          '注文は作成されましたが、一部の商品に未引当があります',
        failed: '社員代理注文を登録できませんでした',
        noResult: '社員代理注文結果を表示できません',
        ecOrderNo: 'EC注文番号',
        items: '商品別結果',
        itemCode: '商品コード',
        itemName: '商品名',
        quantity: '数量',
        status: '結果',
        message: 'メッセージ',
        unallocatedItems: '未引当商品',
        orderedQuantity: '注文数量',
        allocatedQuantity: '引当数量',
        unallocatedQuantity: '不足',
      },
    },
    action: {
      doAction: 'する',
      of: 'の',
      to: 'を',
      close: '閉じる',
      approve: '承認',
      revokeApprove: '承認取消',
      cancel: 'キャンセル',
      delete: '削除',
      edit: '編集',
      save: '保存する',
      csvDownload: 'CSVダウンロード',
      editContent: '発注内容の編集',
      returnToTop: 'トップに戻る',
      result: {
        approved: '承認されました',
        notExists: '発注が存在しません',
        noApprovalAuthority: '承認権限がありません',
        deliveryDateChangeRequired: '配送日の変更が必要です',
        alreadyApproved: '既に承認済みです',
        alreadyShipped: '既に出荷済みです',
        unavailableItems: '利用できない商品があります',
        approvalRevoked: '承認が取り消されました',
        alreadyRevoked: '既に承認が取り消されています',
        cancelled: 'キャンセルされました',
        noCancelAuthority: 'キャンセル権限がありません',
        approvedCannotCancel: '承認済みのためキャンセルできません',
        orderNumber: '発注番号',
        is: 'は',
      },
      message: {
        approve: '発注を承認しました',
        bulkApprove: '発注を一括承認しました',
        revokeApprove: '発注の承認を取り消しました',
        bulkRevokeApprove: '発注の承認を一括取り消しました',
        cancel: '発注をキャンセルしました',
        bulkCancel: '発注を一括キャンセルしました',
        returnToCart: '発注をカートに戻しました',
        updateDeliveryDate: 'ご希望納品日を更新しました',
        updateShippingInfo: 'お届け先情報を更新しました',
        failedUpdateDeliveryDate: 'ご希望納品日を更新できませんでした',
        failedUpdateShippingInfo: 'お届け先情報を更新できませんでした',
        failedUpdateItem: '発注番号{{orderNumber}}の商品を更新できませんでした',
        failedBulkCancel:
          '発注番号{{orderNumbers}}の発注をキャンセルできませんでした',
      },
    },
    field: {
      orderNumber: '発注番号',
    },
    label: {
      visibleOrder: '表示中の注文情報',
      totalItemCount: '注文合計数',
      storeCount: '店舗数',
      totalSalonPrice: 'サロン価格合計',
    },
    modal: {
      editTitle: '発注内容の編集',
      editContent: '発注内容の編集',
      deleteTitle: '商品削除',
      deleteContent: 'この操作は取り消すことができません。',
      warning: {
        overwriteCart: 'カートに上書きします。',
        cannotUndo: 'この操作は取り消すことができません。',
        removeFromOrderHistory: '発注履歴からは発注が削除されます',
      },
      itemDetail: {
        title: '商品詳細',
      },
    },
    payment: {
      title: '支払い情報',
      subtotal: '小計',
      tax: '税額',
      total: '合計',
      order: {
        current: '今回の注文',
        unshipped: '同日お届け予定の他の発注',
        totalPrice: '合計金額',
        untilFreeShippingPrice: '送料無料まで',
      },
      shipping: {
        shippingFee: '送料',
      },
    },
    status: {
      unshipped: '未出荷',
      approved: '承認済',
      unapproved: '未承認',
      error: 'エラー',
    },
    shipping: {
      title: 'お届け先',
      titleShort: '出荷',
      shippingDate: 'お届け日',
      shippingInfo: 'お届け先情報',
      regularDeliveryDate: 'レギュラー納品予定日',
      desiredDeliveryDate: 'ご希望納品日',
      change: '変更',
      zipCode: '郵便番号',
      tel: '電話番号',
      deliveryName: 'お届け先名',
      info: '出荷情報',
      status: '出荷ステータス',
    },
    item: {
      title: '商品',
      purchasePrice: '購入価格',
      salonPrice: 'サロン価格',
      subtotal: '小計',
      quantity: '数量',
      selectMultiple: '商品を複数選択する',
      completeSelection: '商品選択を完了する',
      closeAll: 'すべて閉じる',
      openAll: 'すべて開く',
      backorder: '取寄品',
      backorderNote: '※お届けまでに１週間ほどかかります',
      memo: '備考',
      addSalesType: '売上種別を追加する',
      selectPlaceholder: '選択してください',
      salesType: '種別',
      currentOrder: '今回の発注',
    },
    message: {
      confirmDelete: 'この商品をすべての発注から削除しますか？',
    },
    history: {
      title: '注文履歴',
      titleShort: '発注',
      detail: {
        title: '詳細',
      },
      label: {
        approval: {
          status: '承認ステータス',
        },
        displayCount: '表示件数',
        currency: '円',
        units: '点',
      },
      filter: {
        title: '絞り込み',
        button: '絞り込む',
        reset: '絞り込み条件をリセットする',
        noSpecification: '指定なし',
        selectedStores: '件選択中',
        allStores: 'すべて',
      },
      fields: {
        deliveryDate: 'ご希望納品日',
        orderNo: '発注番号',
        salesOrderNo: '受注番号',
        storeCodes: '店舗',
        shipmentStatus: '出荷ステータス',
        approvalStatus: '承認ステータス',
        salesTypeName: '種別',
        quantity: '数量',
        price: '価格',
        note: 'メモ',
        summaryPrice: '小計',
      },
      card: {
        desiredDeliveryDate: 'ご希望納品日',
        salesOrderNo: '受注番号',
        total: '合計',
        shippingFee: '送料',
        storeName: '店舗',
        trackingNo: '送り状番号',
        freeShippingMessage: '無料まであと',
        freeShipping: '無料',
        shippingCompanyName: '運送会社',
        errorMessage: {
          unapproved: '未承認の発注あり',
          deliveryDateChange: 'ご希望納品日の変更が必要な注文あり',
          cancelledOutOfStock:
            '一部の商品は欠品のため、該当商品の出荷を停止しました。再度ご注文いただく場合は、再購入をお願いします。',
          partialShippingPreparation:
            '一部の商品は欠品のため、該当商品の出荷を停止しました。再度ご注文いただく場合は、再購入をお願いします。',
          partialShipped:
            '一部の商品は欠品のため、該当商品の出荷を停止しました。再度ご注文いただく場合は、再購入をお願いします。',
        },
        none: '設定なし',
      },
      status: {
        all: 'すべて',
        preparation: '準備中',
        shipped: '出荷済',
        approved: '承認済',
        unapproved: '未承認',
        unshipped: '未出荷',
        shippingPreparation: '出荷準備中',
        cancelledOutOfStock: '出荷停止',
        partialShippingPreparation: '一部出荷準備中',
        partialShipped: '一部出荷済',
        error: 'エラー',
      },
      action: {
        approve: '承認',
        revokeApproval: '承認取消',
        cancel: 'キャンセル',
        bulkApprove: '一括承認',
        bulkRevokeApproval: '一括承認取消',
        bulkCancel: '一括キャンセル',
        bulkAction: {
          approve: '承認',
          revokeApproval: '承認取消',
          cancelOrder: '注文キャンセル',
          cancelAllOrder: 'すべての注文をキャンセル',
          cancelUnshippedOrder: '未出荷注文のキャンセル',
          cancelAll: 'すべてキャンセル',
        },
        warning: {
          cancelMessage: '注文をキャンセルします。',
          cancelOrderMessage: '発注をキャンセルします。',
          cancelAllOrderMessage: 'すべての発注をキャンセルします。',
          cannotUndo: 'この操作は取り消すことができません。',
        },
      },
      search: {
        message: {
          noOrders: '条件に合う注文履歴はありません',
          action: {
            research: '条件を変更して再検索してください',
          },
        },
      },
      backorder: {
        title: '取寄品',
        note: '※お届けまでお時間をいただきます',
      },
      emptyState: {
        alt: '注文がない画像',
        noOrders: '注文はありません',
        shopNow: '今すぐショッピング',
      },
    },
    import: {
      title: '注文取込',
      result: {
        title: '注文取込結果',
        type: '取込種別',
        summary: {
          total: '取込合計',
          success: '成功件数',
          failure: '失敗件数',
        },
        count: '{{count}}件',
        tableHeader: {
          orderNumber: '注文番号',
          rowNumber: '行番号',
          result: '取込結果',
          errorCode: 'エラーコード',
          detail: '詳細',
        },
        status: {
          success: '成功',
          error: 'エラー',
        },
        filter: {
          all: 'すべて',
          success: '成功のみ',
          error: 'エラーのみ',
        },
        close: '閉じる',
      },
      search: {
        label: {
          systemType: '種別',
          orderDateFromTo: '取込日時',
        },
        placeholder: {
          systemType: '選択してください',
          orderDateFromTo: '選択してください',
        },
        button: '絞り込む',
        message: {
          failedToFetch: '詳細を取得できませんでした',
          failedToDownload: 'ダウンロードできませんでした',
        },
      },
      table: {
        header: {
          result: '取込結果',
          date: '取込日時',
          type: '種別',
          fileName: 'ファイル名',
          originalFile: '元ファイル',
          executionResult: '取込実行結果',
          resultCount: '取込件数',
        },
        status: {
          error: 'エラーあり',
          failure: '失敗',
          success: '成功',
        },
        resultCount: {
          total: '合計',
          separator: '・',
        },
        action: {
          download: 'ダウンロード',
          viewDetail: '詳細を見る',
        },
        noData: '条件に合うデータがありません。',
      },
    },
  },
  announcement: {
    title: 'お知らせ',
    viewDetails: '詳細を見る',
    close: '閉じる',
    noReadData: '確認済みのお知らせはありません。',
    noUnReadData: '未確認のお知らせはありません。',
    tags: {
      all: 'すべて',
      important: '重要',
      newFeature: '新機能',
      productInfo: '商品情報',
      other: 'その他',
    },
    selectAll: '一括選択',
    markAllRead: '既読にする',
  },
  productHistory: {
    searchForm: {
      changeDate: '変更日',
      productCode: '商品コード',
      makerCode: 'メーカーコード',
      makerSearchButton: '検索',
      startDate: '開始日',
      endDate: '終了日',
      button: '検索',
      dateRangeError: '開始日は終了日以前の日付を入力してください',
      productCodeChange: {
        label: '商品コードの変更',
        yes: '変更あり',
        no: '変更なし',
      },
    },
    makerSearchModal: {
      title: 'メーカー検索',
      makerCode: 'メーカーコード',
      makerName: 'メーカー名',
      search: '検索',
      select: '選択',
      noData: 'データがありません',
    },
    csvDownload: {
      button: 'CSVダウンロード',
      success: 'CSVファイルをダウンロードしました。',
      error:
        'CSVファイル作成中にエラーが発生しました。お手数ですが、時間を空けて再度お試しください。',
      fetchError:
        '生成されたCSVファイルの情報を取得することができませんでした。お手数ですが、時間を空けて再度お試しください。',
    },
    table: {
      noData: 'データがありません',
      header: {
        productCode: '商品コード',
        productName: '商品名',
        oldProductCode: '旧商品コード',
        oldProductName: '旧商品名',
        newProductCode: '新商品コード',
        newProductName: '新商品名',
        makerCode: 'メーカーコード',
        makerName: 'メーカー名',
        oldRetailPrice: '旧上代',
        oldBsPrice: '旧BS価',
        newRetailPrice: '上代',
        newBsPrice: 'BS価',
        effectiveDate: '価格変更日',
        sourceUpdatedAt: 'データ更新日',
      },
    },
  },
  auth: {
    validation: {
      required: '必須項目です',
      requiredInput: '必須入力です',
      minLength: '最小文字数は{length}文字です',
      maxLength: '最大文字数は{length}文字です',
      invalidEmail: '不正なメールアドレスです',
      passwordMismatch: '新しいパスワードが一致しません',
    },
    password: {
      title: 'パスワードを変更',
      currentPassword: '現在のパスワード',
      newPassword: '新しいパスワード',
      newPasswordConfirm: '新しいパスワード（再入力）',
      submit: '更新する',
      close: '閉じる',
      updated: 'パスワードを更新しました',
    },
    email: {
      title: 'メールアドレスを変更',
      newEmail: 'メールアドレス',
      submit: '更新する',
      close: '閉じる',
      complete: {
        message: '保存したアドレスにメールを送信しました。',
        instruction: '届いたメールに記載のURLを開き認証を完了してください。',
      },
    },
    invoiceEmail: {
      title: 'メールアドレスを変更',
      newEmail: 'メールアドレス',
      submit: '更新する',
      close: '閉じる',
      complete: {
        message: '保存したアドレスにメールを送信しました。',
        instruction: '届いたメールに記載のURLを開き認証を完了してください。',
      },
    },
    login: {
      title: 'ログイン',
      email: 'メールアドレス',
      password: 'パスワード',
      submit: 'ログイン',
      storeCode: '店舗コード',
      saveStoreCode: '次回ログイン時に同じ店舗コードを使用する',
      button: 'ログインする',
      userId: 'ユーザーID',
    },
    employeeLogin: {
      forgotPassword: {
        prefix: 'ログインができない場合、パスワードをお忘れの場合は',
        linkText: 'こちら',
        suffix: 'のフォームよりお問い合わせください。',
      },
    },
    changeEmail: {
      authenticating: '認証中...',
      authFailed: '認証に失敗しました。',
      authComplete: 'メールアドレスの認証が完了しました。',
      invalidToken: '認証メールのURLが間違っているか、有効期限が切れています。',
      returnToTop: 'トップに戻る',
    },
    modal: {
      categorySelection: 'カテゴリ選択',
    },
  },
  brand: {
    group: {
      title: 'ブランドグループ',
    },
    item: {
      title: 'ブランド',
    },
  },
  cart: {
    item: {
      title: 'カート',
      count: 'カート内の商品数',
      empty: 'カートは空です',
      add: 'カートに追加する',
      add_description: '選択した商品を{{cart}}に追加します。',
      remove: 'カートから削除',
      quantity: '数量',
      price: '価格',
      total: '合計',
      noItems: '{{title}}に商品がありません',
      action: {
        remove: 'カートを空にする',
        close: '閉じる',
        empty: '空にする',
        message: {
          clear: 'カートを空にしました',
          remove: 'カートから商品を削除しました',
        },
      },
      message: {
        remove: 'カートを空にします。よろしいですか？',
        notUndo: 'この操作は元に戻せません。',
        unavailableItems:
          '注文できない商品があります。削除してから購入手続きにお進みください。',
      },
    },
    shipping: {
      title: 'お届け情報',
      address: 'お届け先',
      addressInfo: 'お届け先情報',
      name: 'お名前',
      postalCode: '郵便番号',
      phone: '電話番号',
      edit: '編集',
      add: '追加',
      close: '閉じる',
      submit: '保存',
      searchByPostalCode: '郵便番号から住所検索する',
      defaultAddress: 'デフォルトの{{title}}を指定する',
      message: {
        update: 'お届け先情報を更新しました',
        overDesiredDeliveryDate:
          'お届け可能な納品日が更新されました。カートを再表示します',
      },
      validation: {
        required: '必須項目です',
        maxLength: '最大文字数は{{length}}文字です',
        invalidPostalCode: '郵便番号が正しくありません',
        emojiNotAllowed:
          '絵文字を入力することはできません（検知された文字：{{char}}）',
        fullWidthRequired:
          'すべて全角で入力してください（検知された文字：{{char}}）',
        invalidCharacters: '入力できない文字が含まれています',
      },
    },
    payment: {
      title: 'お支払い',
      subtotal: '小計',
      tax: '消費税',
      total: '金額',
      proceed: '購入手続きへ',
      currency: '円',
      salonPrice: 'サロン価格',
      purchasePrice: '購入価格',
      untilFreeShipping: '送料無料まで',
      note: '※同日お届けの他の発注を含む',
      error: 'エラー',
      confirmOrder: {
        title: '代理注文の確認',
        proceed: '注文する',
        cancel: '戻る',
        message1: '以下の得意先の代理注文を行います。',
        message2: 'よろしいですか？',
        salonName: 'サロン',
      },
    },
    date: {
      title: 'ご希望納品日',
      select: 'お届け日を選択',
      regular: 'レギュラー納品予定日',
      change: '変更',
      regularLabel: 'レギュラー納品予定日：{{date}}',
      error: {
        required: 'お届け日を選択してください',
        invalid: '無効なお届け日です',
        unavailable: '選択された日はお届けできません',
        updated:
          'お届け可能な納品日が更新されました。ご希望納品日を再選択してください。',
      },
      message: {
        update: 'ご希望納品日を更新しました',
      },
    },
    placeholder: {
      noMax: '上限なし',
      noMin: '下限なし',
    },
  },
  item: {
    title: '商品',
    search: {
      title: '商品検索',
      placeholder: {
        common: '商品名、JANコード、カタログ番号で検索',
      },
      action: {
        bulkSelect: '商品を複数選択する',
        bulkSelectComplete: '商品選択を完了する',
      },
      message: {
        changeConditions: '条件を変更して再検索してください',
      },
      error: {
        noResults: '条件に合う商品がありません',
      },
    },
    order: {
      detail: '詳細',
      edit: '編集',
      delete: '削除',
      quantity: '数量',
      price: '価格',
      total: '合計',
      close: '閉じる',
      save: '保存する',
      memo: 'メモ',
      units: '点',
      currency: '円',
      salonPrice: 'サロン価格',
      purchasePrice: '購入価格',
      purchasePriceTotal: '購入価格合計',
      averagePurchasePrice: '平均購入単価',
      addSalesType: '売上種別を追加する',
      salesType: '売上種別',
    },
    status: {
      available: '利用可能',
      unavailable: '利用不可',
      expired: '注文期間外',
      forbidden: '担当営業へお問合せ下さい',
      noItemCode: '存在しない商品コード',
      outOfStock: '在庫切れ',
      discontinued: '販売終了',
    },
    card: {
      detail: '詳細',
      color: {
        all: 'すべての色',
      },
      status: {
        unavailable: '一時注文停止中（営業担当にお問合せください）',
        expired: '注文期間外',
        forbidden: '担当営業へお問合せ下さい',
        noItemCode: '存在しない商品コード',
        outOfStock: '在庫切れ',
        discontinued: '販売終了',
      },
    },
    favorite: {
      add: 'お気に入りに追加する',
      remove: 'お気に入りから削除する',
      modal: {
        title: 'お気に入りに追加',
        submit: '追加する',
        cancel: 'キャンセル',
        createNew: '新しいリストを作成する',
        filter: 'フィルター',
      },
    },
    cart: {
      add: 'カートに追加',
      edit: '発注内容の編集',
      close: '閉じる',
      remove: 'カートから削除する',
      title: 'カート',
      addSuccess: 'に追加しました',
      addToCart: 'カートに追加する',
    },
    unit: '点',
    detail: {
      view: '詳細をみる',
      title: '商品詳細',
      allColors: 'すべての色',
      sort: '並び替え',
      detailedSearch: '詳細検索',
      searchCondition: '検索条件',
      searchResults: '検索結果：',
      search: '検索',
      keyword: 'キーワード',
      searchButton: '検索する',
      purchasePrice: '購入価格',
      subtotal: '小計',
      itemName: '商品名',
      brandName: 'ブランド名',
      salonPrice: 'サロン価格',
      retailPrice: 'メーカー希望小売価格',
      manufacturer: 'メーカー',
      volume: '容量',
      janCode: 'JANコード',
      itemCode: '商品コード',
      latestOrderDate: '最終注文日',
      salesStartDate: '販売開始日',
      order: '注文する',
      orderLimitExceeded: '在庫数量は{{count}}点までです',
      loading: '読み込み中...',
      loadingError: '読み込みエラーが発生しました',
      noResults: '検索結果がありません',
      productImage: '商品画像',
      lastOrderDate: '前回到着予定日',
      brandStartDate: 'ブランド取扱日',
      cartDetail: 'カート内商品の詳細',
    },
    list: {
      backorder: '取寄品',
      selectAll: 'すべて選択',
      latest: '最新版',
      sort: {
        title: '並び替え',
        brandNameAsc: 'ブランド名の昇順',
        brandNameDesc: 'ブランド名の降順',
        itemNameAsc: 'アイテム名の昇順',
        itemNameDesc: 'アイテム名の降順',
        salonPriceAsc: 'サロン価格が低い順',
        salonPriceDesc: 'サロン価格が高い順',
        salesStartDateAsc: '販売開始日古い順',
        salesStartDateDesc: '販売開始日最新順',
      },
    },
    selector: {
      selected: '選択済み',
      selectItems: '{{count}}点の商品を選択',
    },
    validation: {
      required: '必須項目です',
      min: '{{min}}未満です',
      max: '{{max}}を超えています',
      maxLength: '{{max}}文字を超えています',
      invalidRange: '下限は上限より小さい値を入力してください',
      categoryMaxExceeded: 'カテゴリ指定数が最大数を超えています',
      brandMaxExceeded: 'ブランド指定数が最大数を超えています',
      memoMaxBytesExceeded: '全角7文字／半角14文字以内で入力してください',
    },
    detailedSearch: {
      title: '詳細検索',
      categorySelect: 'カテゴリ選択',
      brandSelect: 'ブランド選択',
      unselected: '未選択',
      keywords: 'キーワード',
      salonPrice: 'サロン価格',
      retailPrice: 'メーカー希望小売価格',
      salesStart: '販売開始日',
    },
    orderDetail: {
      title: 'カート内商品の詳細',
      salesType: '種別',
      quantity: '数量',
      memo: 'メモ',
      price: '購入価格',
      subtotal: '小計',
      close: '閉じる',
      edit: '編集する',
    },
    notSpecified: '指定なし',
    deleteItem: 'アイテムを削除',
    deleteConfirmation: '{{itemName}}を削除します。',
    cannotUndo: 'この操作は元に戻せません。',
    delete: '削除',
    close: '閉じる',
    confirmDelete: '削除',
    edit: '編集',
    quantity: '数量',
    quantityLabel: '数量: {{count}}点',
    salonPrice: 'サロン価格',
    salonPriceLabel: 'サロン価格: ¥{{price}}',
    subtotal: '小計',
    subtotalLabel: '小計: ¥{{amount}}',
    purchasePrice: '購入価格',
    purchasePriceSubtotal: '購入価格小計',
    purchasePriceSubtotalLabel: '購入価格小計: ¥{{amount}}',
    unavailableForPurchase: '購入不可（営業にお問い合わせください）',
    unavailableForRegistration: '登録不可（営業にお問い合わせください）',
    cancelAllOrder: '発注をキャンセル',
    cancelButton: 'キャンセル',
    approvalStatus: 'ステータス',
    separator: '／',
    units: '点',
    currency: '円',
  },
  lineup: {
    title: 'ラインアップ',
  },
  category: {
    title: 'カテゴリー',
    all: 'すべて',
    products: '商品',
    count: '件',
  },
  colorChart: {
    title: 'カラーチャート',
    selectAll: 'すべて選択',
    color: '色',
    allColors: 'すべての色をみる',
    completeItemSelection: '商品選択を完了する',
    selectMultipleItems: '商品を複数選択する',
  },
  contact: {
    form: {
      title: 'お問い合わせフォーム',
      userId: 'ユーザーID',
      storeName: '店舗名',
      email: 'メールアドレス',
      tel: '電話番号',
      business: 'ご用件',
      contents: 'お問い合わせ内容',
      submit: '送信する',
      placeholder: {
        input: '入力してください',
        tel: 'ハイフンなしで入力してください',
        select: '選択してください',
      },
      business_options: {
        password: 'パスワードをお忘れの場合',
        locked_account: 'ログインロックの解除',
        app: 'サイト機能について',
        other: 'その他のお困りごと',
      },
      note: '※ご注文内容・商品・請求書に関するお問い合わせは担当営業までご連絡ください。\n※お問い合わせ内容により、お時間をいただく場合がございます。予めご了承ください。',
      validation: {
        required: '必須項目です',
        maxLength: '最大文字数は{max}文字です',
        invalidEmail: '不正なメールアドレスです',
      },
    },
    placeholder: {
      email: 'support@altair.mobi',
    },
    title: 'お問い合わせ',
    helpText: '問題が解決しない場合はこちら',
    submit: '問い合わせる',
    orderInquiries:
      'ご注文内容・商品・請求書に関するお問い合わせは、担当営業または担当支店にお問い合わせください。',
    branchHint:
      '※担当支店名が不明の場合、納品書もしくは請求書の右上をご確認ください。',
    branchListPrefix: '※支店の電話番号一覧は',
    branchListLink: 'こちら',
    otherInquiries: '上記以外のお問い合わせはこちらから',
    links: {
      forgotPassword: 'パスワードをお忘れの場合',
      unlockAccount: 'ログインロックの解除',
      appFeatures: 'サイトの機能について',
      otherIssues: 'その他のお困りごと',
    },
    menu: {
      guide: 'ご利用ガイド',
      faq: 'FAQ（よくあるご質問）',
      help: 'ヘルプ',
      contact: 'お問い合わせ',
      privacyPolicy: 'プライバシーポリシー',
      termsOfService: '利用規約',
      law: '特定商取引法に基づく表記',
    },
    complete: {
      title: '{{title}}が完了しました',
      emailSetting:
        '※「{{email}}」からのメールを受信できるよう、受信設定をご確認ください。',
      responseTime:
        '※{{title}}内容により、お時間をいただく場合がございます。予めご了承ください。',
      businessHours: '■営業時間：月曜から金曜　9：00～18：00',
      holidays:
        '■定休日：土日祝日（営業時間外のお問合せは、翌営業日以降にご連絡いたします）',
      returnToTop: 'トップに戻る',
    },
  },
  favorite: {
    title: 'お気に入り',
    titleAlias: 'お気に入りリスト',
    list: {
      title: 'お気に入りリスト',
      create: '新しいリストを作成する',
      edit: 'リストの設定',
      name: 'リストの名称',
      shared: '他のサロンへの共有',
      share: '共有する',
      not_share: '共有しない',
      delete: '削除',
      duplicate: '複製',
      title_edit: 'タイトル編集',
      title_edit_share: 'タイトル編集・共有設定',
      sales_type: {
        title: 'デフォルト販売種別',
        add: '販売種別を追加する',
        max: '最大{{max}}件まで',
        description:
          'お気に入りリスト（{{name}}）内で、初期表示する種別を設定することができます。',
        setting: 'このリストのデフォルト販売種別を設定する',
        close: '閉じる',
        save: '保存する',
      },
      validation: {
        required: '必須入力です',
        max_length: '最大文字数は{{max}}文字です',
      },
      sharing: {
        title: '各店舗への共有',
        share: '共有する',
        not_share: '共有しない',
      },
      action: {
        message: {
          create: 'お気に入りリストを作成しました',
          update: 'お気に入りリストを更新しました',
          updateSetting: 'お気に入りリストの設定を更新しました',
          sort: 'お気に入りリストの並び順を更新しました',
          delete: 'お気に入りリストを削除しました',
          copy: '選択されたお気に入りアイテムをコピーしました',
        },
      },
    },
    item: {
      title: 'お気に入りアイテム',
      count: '{{count}}件',
      count_unit: '点',
      empty: 'アイテムがありません',
      add: '追加',
      remove: '削除',
      remove_description: {
        line1: '選択されている商品を',
        line2: 'お気に入りリスト「{{name}}」から削除します。',
      },
      move: '移動',
      copy: 'コピー',
      edit: '編集',
      selected_count: '{{count}}件選択中',
      sort: '並び替え',
      sort_title: '並び替え',
      settings: '種別設定',
      bulkUpdate: 'まとめて販売種別・数量設定',
      bulkUpdateDescription:
        '現在選択されている商品の販売種別・数量を 一括変更します。',
      moveFolder: 'フォルダの移動',
      moveDescription:
        '選択されている商品を移動またはコピーするフォルダを選択してください。',
      myListEmpty: 'マイリストがありません',
      listEmpty: 'リストがありません',
      editList: 'リストの編集',
      selectAll: 'すべて選択',
      janCode: 'JANコード',
      productCode: '商品コード',
      action: {
        message: {
          sort: 'お気に入りアイテムの並び順を更新しました',
          copy: '選択されたお気に入りアイテムをコピーしました',
          move: '選択されたお気に入りアイテムを移動しました',
          delete: '選択されたお気に入りアイテムを削除しました',
          addCart: '選択されたお気に入りアイテムをカートに追加しました',
        },
      },
    },
    modal: {
      add: 'お気に入りに追加',
      cancel: 'キャンセル',
      confirm: '確認',
      close: '閉じる',
      save: '保存',
      save_item: '保存する',
      delete: '削除',
      copy: 'コピーする',
      move: '移動する',
      delete_title: '削除',
      delete_description: 'この操作は取り消すことができません。',
    },
    notification: {
      create: 'お気に入りリストを作成しました',
      update: 'お気に入りリストを更新しました',
      delete: 'お気に入りリストを削除しました',
      item_add: 'お気に入りにアイテムを追加しました',
      item_remove: 'お気に入りからアイテムを削除しました',
      item_move: 'お気に入りアイテムを移動しました',
      item_copy: 'お気に入りアイテムをコピーしました',
    },
    error: {
      fetchDetailFailed: 'お気に入りの詳細情報を取得できませんでした',
    },
    bulkUpdate: {
      mode: {
        both: '両方',
        salesType: '販売種別',
        quantity: '数量',
      },
      validation: {
        required: '必須項目です',
        min: '{min}未満です',
        max: '{max}を超えています',
      },
    },
  },
  guide: {
    title: 'ご利用ガイド',
    relatedItems: '関連する項目',
  },
  help: {
    title: 'ヘルプ',
    error: {
      fetchFailed: 'コンテンツを取得できませんでした',
      tryAgainLater: 'お手数ですが、時間を置いて再度ご確認ください',
    },
    close: '閉じる',
    button: {
      addOtherItemToConfirmedOrder: '以下にない商品を追加したい場合には？',
    },
  },
  receipt: {
    title: '領収書',
    list: {
      title: '領収書一覧',
      empty: '領収書がありません',
      download: 'ダウンロード',
      preview: 'プレビュー',
      history: '履歴',
      status: {
        all: 'すべて',
        paid: '支払済',
      },
    },
  },
  invoice: {
    title: '請求書',
    file: {
      preview: 'プレビュー',
      download: 'ダウンロード',
      bulk: '一括ダウンロード',
      history: '履歴',
      status: {
        downloaded: 'ダウンロード済み',
        notDownloaded: 'ダウンロードが必要',
        mailed: '郵送済み',
        invalid: '無効になったバージョン',
        noInvoice: '請求なし',
      },
    },
    notFound: {
      common:
        '検索条件に合う請求書がありません。\n条件を変更して再度検索してください。',
      filter:
        'フィルターの条件に合う請求書がありません。\n条件を変更して再度検索してください。',
      history:
        '条件に合う履歴が見つかりませんでした。\n条件を変更して再度検索してください。',
      preview:
        '条件に合うプレビューが見つかりませんでした。\n条件を変更して再度検索してください。',
    },
    list: {
      title: '請求書一覧',
      empty: '請求書がありません',
      download: 'ダウンロード',
      preview: 'プレビュー',
      history: '履歴',
      status: {
        all: 'すべて',
        paid: '支払済',
        unpaid: '未払い',
        overdue: '期限超過',
      },
      bulk: {
        downloadZip: 'zipにまとめてダウンロード',
        latest: '最新版',
      },
    },
    filter: {
      title: 'フィルター',
      apply: '適用',
      reset: 'リセット',
      close: '閉じる',
      dateRange: '期間',
      status: 'ステータス',
      store: '店舗',
      search: '検索',
      placeholder: {
        partialMatch: '部分一致',
      },
      sort: {
        invoiceNameAsc: '請求先名　昇順',
        invoiceNameDesc: '請求先名　降順',
        invoiceCodeAsc: '請求先コード　昇順',
        invoiceCodeDesc: '請求先コード　降順',
        invoicePriceAsc: '請求金額　昇順',
        invoicePriceDesc: '請求金額　降順',
        invoicePublishAsc: '最終発行日　昇順',
        invoicePublishDesc: '最終発行日　降順',
        invoiceClosingAsc: '請求締日　昇順',
        invoiceClosingDesc: '請求締日　降順',
      },
    },
    search: {
      title: '請求書検索',
      placeholder: '請求書を検索',
      byMonth: '請求月で絞り込み',
      byClosingDate: '請求締日で絞り込み',
      invalidRange: '終了月は開始月以降を指定してください',
      byStore: '店舗別検索',
      multiStore: '複数店舗検索',
      download: 'ダウンロード',
      selectMonth: '月を選択',
      selectStore: '店舗を選択',
      status: {
        all: 'すべて表示する',
        notDownloaded: '未ダウンロードの請求先',
        downloadedAndMailed: 'ダウンロード済み/郵送の請求先',
      },
      year: '年',
      month: '月',
    },
    preview: {
      title: '請求書プレビュー',
      close: '閉じる',
      download: 'ダウンロード',
      notFound: 'が見つかりませんでした',
      systemError: 'システムエラーが発生しました',
    },
    history: {
      title: '請求書履歴',
      close: '閉じる',
      date: '日付',
      action: 'アクション',
      user: 'ユーザー',
      noHistory: '履歴がありません',
      downloadCsv: '履歴のCSVをダウンロード',
      operation: {
        cancelMailed: '郵送キャンセル',
        delete: '削除',
        download: 'ダウンロード',
        drafted: '下書き',
        mailed: '郵送済み',
        opDownloaded: 'ダウンロード（運用部）',
        published: '公開',
        rejected: '公開前の削除',
        unpublished: '取り下げ',
      },
    },
    download: {
      title: 'ダウンロード',
      progress: 'ダウンロード中',
      complete: 'ダウンロード完了',
      failed: 'ダウンロード失敗',
      retry: '再試行',
      receipt: '領収書',
      receiptDownload: '領収書ダウンロード',
    },
    detail: {
      invoiceNumber: '請求書番号',
      billingClosingDate: '請求締日',
      issueDate: '発行日',
      dueDate: '支払期限',
      totalAmount: '合計金額',
      status: 'ステータス',
      items: '項目',
      subtotal: '小計',
      tax: '消費税',
      total: '合計',
    },
  },
  purchase: {
    common: {
      filter: '絞り込む',
    },
    csv: {
      download: 'CSVダウンロード',
      downloading: 'ファイルをダウンロード中です',
      downloadingMessage: '完了するまでしばらくお待ちください',
      cancel: 'キャンセル',
    },
    searchForm: {
      importDate: '取込日時',
      shippingDate: '出荷日',
      systemType: 'システム種別',
      ecSalesOrderNo: 'EC注文番号',
      placeholder: {
        importDate: '選択してください',
        shippingDate: '選択してください',
        systemType: '選択してください',
        ecSalesOrderNo: '入力してください',
      },
    },
    fields: {
      ecSalesOrderNo: 'EC注文番号',
      importDateTime: '取込日時',
      systemType: 'システム種別',
      shippingDate: '出荷日',
      trackingNos: '送り状番号',
      fileName: 'ファイル名',
      deliveryId: '送付先ID',
      deliveryName: 'お届先名称',
      deliveryAddress: 'お届先都道府県',
      desiredDeliveryDate: '配送希望日',
      desiredDeliveryTime: '配送希望時間',
      scheduledShippingDate: '出荷予定日',
      scheduledArrivalDate: '着荷予定日',
      shippingWarehouse: '出荷倉庫',
      shippingCompany: '運送会社',
      salesOrderNo: '受注番号',
      salesNos: '売上番号',
      startFrom: 'から始まる',
    },
    table: {
      ecOrderNo: 'EC注文番号',
      importDateTime: '取込日時',
      shippingDate: '出荷日',
      trackingNo: '送り状番号',
      systemType: '種別（送付先ID）',
      deliveryAddress: 'お届け先都道府県',
      deliveryName: 'お届け先名',
      deliveryCompanyName: '運送会社',
    },
    orderItems: {
      rowNo: '行番号',
      janCode: 'JAN',
      itemName: '商品名',
      quantity: '数量',
    },
    kvList: {
      importDateTime: '取込日時',
      shippingDate: '出荷日',
      trackingNos: '送り状番号',
      systemType: '種別',
      ecSalesOrderNo: 'EC注文番号',
      fileName: 'ファイル名',
      deliveryId: '送付先ID',
      deliveryName: 'お届け先名',
      deliveryAddress: 'お届け先住所',
      desiredDeliveryDate: 'ご希望配送日',
      desiredDeliveryTime: 'ご希望配送時間帯',
      scheduledShippingDate: '出荷予定日',
      scheduledArrivalDate: '到着予定日',
      shippingWarehouse: '出荷倉庫',
      shippingCompany: '配送業者',
      salesOrderNo: '受注番号',
      salesNos: '受注番号',
    },
    shipmentStatus: {
      unshipped: '未出荷',
      shipped: '出荷済み',
    },
  },
  purchasedInfo: {
    common: {
      search: '検索する',
      clearSearch: '検索条件をクリア',
      noData: '条件にあう項目がありません。',
      noDataMessage: '条件を変更して再度検索してください。',
      downloading: 'ファイルをダウンロード中です',
      downloadingMessage: '完了するまでしばらくお待ちください',
      cancel: 'キャンセル',
      csvDownload: 'CSVダウンロード',
      total: '全',
      unit: '件',
      failedToDownload: 'ダウンロードできませんでした',
    },
    form: {
      selectPlaceholder: '選択してください',
      orderDate: '注文日',
      shippingDate: '出荷日',
      storeCode: '店舗',
      unit: '集計単位',
      statTarget: '集計対象',
      billMonth: '請求月',
      itemCode: '商品コード',
      allStores: 'すべての店舗',
      notSpecified: '指定なし',
      startDate: '開始日',
      endDate: '終了日',
    },
    unit: {
      store: '得意先',
      billStore: '請求先',
      depositStore: '入金親',
    },
    statTarget: {
      orderStat: '注文',
      billingStat: '請求',
    },
    subTitle: {
      salesDetail: '明細',
      billedAmounts: '請求金額一覧',
      makers: 'メーカー別',
      makersStores: 'メーカー別店舗別',
      stores: '店舗別',
      storesSalesTypes: '店舗別売上種別別',
      storesMakersSalesTypes: '店舗別メーカー別売上種別',
    },
    dataList: {
      backButton: '戻る',
    },
    details: {
      salesDetail:
        '受注日 / 出荷日 / 売上番号 / 売上行番号 / 店舗コード / 店舗名 / 売上種別 / メーカー / 商品コード / 商品名 / JANコード / カテゴリ / 受注数量 / 出荷数量 / 単価 / 金額 / 備考 / サロン価格 / メーカー希望小売価格 / 取込番号',
      billedAmounts:
        '請求日 / お支払日 / 請求No. / 請求先コード / 請求先名 / 繰越額 / 当月売上合計 / 伝票調整 / 消費税 / 今回請求金額',
      makers: 'メーカー / メーカーコード / 受注数量 / 出荷数量 / サロン価格',
      makersStores: '店舗ID / 店舗名 / メーカー名 / 送料',
      stores: '店舗ID / 店舗名 / 受注数量 / 出荷数量 / サロン価格',
      storesSalesTypes: '店舗ID / 店舗名 / 売上種別',
      storesMakersSalesTypes: '店舗ID / 店舗名 / メーカーコード・売上種別',
    },
    subPage: {
      title: {
        salesDetail: '明細',
        billedAmounts: '請求金額一覧',
        makers: 'メーカー別',
        makersStores: 'メーカー別店舗別',
        stores: '店舗別',
        storesSalesTypes: '店舗別売上種別別',
        storesMakersSalesTypes: '店舗別メーカー別売上種別',
      },
    },
  },
  orderHistory: {
    statusBar: {
      desiredDeliveryDateError: 'ご希望納品日の変更が必要な注文あり',
      unapprovedOrder: '未承認の注文あり',
    },
    paymentTable: {
      salonPrice: 'サロン価格',
      purchasePrice: '購入価格',
      totalAmount: '合計金額',
      untilFreeShipping: '送料無料まで',
      subtotal: '小計',
    },
    footer: {
      totalPriceDisplay: '合計価格表示',
      approvalCancel: '承認取り消し',
      approve: '承認する',
    },
    list: {
      backOrderItems: '取寄品',
      backOrderNote: '※お届けまでお時間をいただきます',
      orderNumber: '発注番号',
      error: 'エラー',
      cancel: 'キャンセル',
      cancelConfirmation: '発注キャンセル',
      cancelMessage: '発注（{orderNo}）をキャンセルします。',
      cancelWarning: 'この操作は取り消すことができません。',
      close: '閉じる',
      cancelOrder: 'キャンセルする',
      bulkCancelUnshipped: '未出荷の発注を一括キャンセルする',
    },
    detail: {
      orderNumber: '受注番号：',
      deliveryInfo: 'お届け情報',
      trackingNumber: '送り状番号',
      desiredDeliveryDate: 'ご希望納品日',
      deliveryAddress: 'お届け先',
      shippingCompanyName: '運送会社',
      purchasedItems: '購入商品',
      byItem: '商品別',
      byOrderNumber: '発注番号別',
      register: '登録',
      repurchase: '再購入',
      back: '戻る',
      none: '設定なし',
    },
    item: {
      notSpecified: '指定なし',
      deleteItem: '商品削除',
      deleteConfirmation: '{itemName}を削除します。',
      cannotUndo: 'この操作は取り消すことができません。',
      delete: '削除',
      close: '閉じる',
      confirmDelete: '削除する',
      detail: '詳細',
      edit: '編集',
      quantity: '数量',
      quantityLabel: '数量：{count}点',
      salonPrice: 'サロン価格',
      salonPriceLabel: 'サロン価格：{price}円',
      subtotal: '小計',
      subtotalLabel: '小計：{amount}円',
      purchasePrice: '購入価格',
      purchasePriceSubtotal: '購入価格小計',
      purchasePriceSubtotalLabel: '購入価格小計：{amount}円',
      averagePurchasePrice: '平均購入単価',
      unavailableForPurchase: '購入不可（営業担当にお問合せください）',
      unavailableForRegistration: '登録不可（営業担当にお問合せください）',
      cancelAllOrder: '発注をキャンセルする',
      cancelButton: 'キャンセル',
      approvalStatus: 'ステータス',
    },
    filter: {
      validation: {
        storeSelection: '1店舗以上選択してください',
        dateRange: '終了日は開始日より前の日付にしてください',
      },
    },
  },
  orderImport: {
    csvUploader: {
      noFileSelected: 'ファイルが選択されていません',
      register: '登録',
      fileTooLarge:
        'ファイルサイズが上限を超えています。3.5MB以下のCSVファイルをアップロードしてください。',
    },
    timeout: {
      notification: 'お知らせ',
      message:
        '処理に時間がかかっています。\nしばらくしてから注文取込をご覧ください',
      close: '閉じる',
    },
    main: {
      title: '注文取込（全{{total}}件）',
    },
    result: {
      showAll: 'すべて表示する',
      showSuccessOnly: '成功のみ表示する',
      showErrorOnly: '失敗のみ表示する',
    },
    searchForm: {
      systemType: '取込種別',
      orderDateFromTo: '取込日',
      startDate: '開始日',
      endDate: '終了日',
      dateRangeError: '終了日は開始日より前の日付にしてください',
    },
  },
  passwordReset: {
    title: 'パスワードを変更してください',
    form: {
      password: 'パスワード',
      passwordConfirm: 'パスワード（確認用）',
      passwordHint: '6文字以上、20文字以下のパスワードを入力してください。',
      save: '保存する',
      requiredField: '必須項目です',
      minLength: '最小文字数は{length}文字です',
      maxLength: '最大文字数は{length}文字です',
      passwordMismatch: 'パスワードが一致しません',
      noPermission: 'パスワードの変更権限がありません。',
    },
  },
  employeeHeader: {
    agencyStatusSuffix: 'に代理ログイン中',
    agencyNotSelected: '代理する得意先は設定されていません',
    changeAgency: '変更する',
    agencySelectionTitle: '代理する得意先の選択',
    agencySelectionDescription: '代理する得意先を選択して下さい。',
    customerCodeLabel: '得意先コード',
    depositParentCodeLabel: '入金親コード',
    close: '閉じる',
    confirm: '決定',
    or: 'もしくは',
    stopAgency: '代理操作をやめる',
  },
  selectStore: {
    title: '代理する得意先を選択',
    description: '代理注文等の操作を行う場合は、対象の得意先を選択して下さい。',
    customerCodeLabel: '得意先コード',
    storeNameLabel: '店舗名',
    depositParentCodeLabel: '入金親コード：',
    loginWithStore: 'この店舗でログイン',
    searchButton: '検索',
    or: 'もしくは',
    loginWithoutSelection: '代理する得意先を選択せずにログインする',
    noResults: '該当する結果がありません',
  },
  privacyPolicy: {
    title: 'プライバシーポリシー',
  },
  termsOfService: {
    title: 'ご利用規約',
  },
  tokushoho: {
    title: '特定商取引法に基づく表記',
  },
  search: {
    title: '検索',
    freeWord: 'フリーワードで検索する',
    detailedSearch: '詳細検索',
    barcodeSearch: 'バーコード検索する',
    byCondition: '条件を指定して検索する',
    byCategory: 'カテゴリから探す',
    byBrand: 'ブランドから探す',
  },
  barcode: {
    readerScan: 'バーコードリーダーで読み込み',
    readerConnectionGuide:
      'バーコードリーダーを接続して、\n商品のバーコードを読み込んでください',
    scanItem: 'バーコードを読み込むと商品が表示されます',
    searching: '商品を検索中...',
    itemAdded: '商品を追加しました',
    itemFound: '商品が見つかりました',
    itemNotFound: '商品が見つかりませんでした',
    addToCart: 'カートに追加',
    totalItems: '合計点数',
    subtotal: '小計',
  },
} as const

// 全ての末端の値を string 型として許容する構造的な型を定義
type DeepReplace<T, From, To> = T extends From
  ? To
  : T extends object
  ? { [K in keyof T]: DeepReplace<T[K], From, To> }
  : T

export type TranslationDict = DeepReplace<typeof dict, Readonly<string>, string>

export default dict
